/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { DurationChoiceResource } from './';
import {
    DurationChoiceResourceFromJSON,
    DurationChoiceResourceFromJSONTyped,
    DurationChoiceResourceToJSON,
} from './';
import type { ProjectType } from './';
import {
    ProjectTypeFromJSON,
    ProjectTypeFromJSONTyped,
    ProjectTypeToJSON,
} from './';
import type { WeeklyAvailability } from './';
import {
    WeeklyAvailabilityFromJSON,
    WeeklyAvailabilityFromJSONTyped,
    WeeklyAvailabilityToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectDetailsResource
 */
export interface ProjectDetailsResource {
    /**
     * 
     * @type {number}
     * @memberof ProjectDetailsResource
     */
    budget?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectDetailsResource
     */
    currencyCode?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectDetailsResource
     */
    dailyFreelancerRate?: number;
    /**
     * 
     * @type {DurationChoiceResource}
     * @memberof ProjectDetailsResource
     */
    durationChoice?: DurationChoiceResource;
    /**
     * 
     * @type {ProjectType}
     * @memberof ProjectDetailsResource
     */
    projectType?: ProjectType;
    /**
     * 
     * @type {Date}
     * @memberof ProjectDetailsResource
     */
    startDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ProjectDetailsResource
     */
    subject: string;
    /**
     * 
     * @type {WeeklyAvailability}
     * @memberof ProjectDetailsResource
     */
    freelancerWeeklyAvailability?: WeeklyAvailability;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectDetailsResource
     */
    hideFreelancerDailyRate: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProjectDetailsResource
     */
    description?: string;
}

/**
 * Check if a given object implements the ProjectDetailsResource interface.
 */
export function instanceOfProjectDetailsResource(value: object): value is ProjectDetailsResource {
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('hideFreelancerDailyRate' in value) || value['hideFreelancerDailyRate'] === undefined) return false;
    return true;
}

export function ProjectDetailsResourceFromJSON(json: any): ProjectDetailsResource {
    return ProjectDetailsResourceFromJSONTyped(json, false);
}

export function ProjectDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'budget': json['budget'] == null ? undefined : json['budget'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'dailyFreelancerRate': json['dailyFreelancerRate'] == null ? undefined : json['dailyFreelancerRate'],
        'durationChoice': json['durationChoice'] == null ? undefined : DurationChoiceResourceFromJSON(json['durationChoice']),
        'projectType': json['projectType'] == null ? undefined : ProjectTypeFromJSON(json['projectType']),
        'startDate': (new Date(json['startDate'])),
        'subject': json['subject'],
        'freelancerWeeklyAvailability': json['freelancerWeeklyAvailability'] == null ? undefined : WeeklyAvailabilityFromJSON(json['freelancerWeeklyAvailability']),
        'hideFreelancerDailyRate': json['hideFreelancerDailyRate'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function ProjectDetailsResourceToJSON(value?: ProjectDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'budget': value['budget'],
        'currencyCode': value['currencyCode'],
        'dailyFreelancerRate': value['dailyFreelancerRate'],
        'durationChoice': DurationChoiceResourceToJSON(value['durationChoice']),
        'projectType': ProjectTypeToJSON(value['projectType']),
        'startDate': ((value['startDate']).toISOString().substring(0,10)),
        'subject': value['subject'],
        'freelancerWeeklyAvailability': WeeklyAvailabilityToJSON(value['freelancerWeeklyAvailability']),
        'hideFreelancerDailyRate': value['hideFreelancerDailyRate'],
        'description': value['description'],
    };
}

